module.exports = __webpack_public_path__ + "static/media/6_of_hearts.322d926a.png";